import { LitElement, html, css, nothing } from 'lit';
import { customElement, property, state, query } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { load, resetCompositionState } from '../../store/composition/composition';
import { translate } from '../../helpers/translate.js';
import { compositionTypes } from '../../store/composition/helpers.js';
import '@sdb-develop/learning-frontend';
import '../shared/sdb-player-dialog.js';

@customElement('sdb-composition-reset-button')
class SdbCompositionResetButton extends connect(store)(LitElement)
 {

    @property({ type: String })
    accessor targetId;

    @property({ type: String })
    accessor compositionId;

    @property({ type: String })
    accessor label;

    @property({ type: Boolean })
    accessor disabled = false;

    @property({type: Boolean})
    accessor light = false;

    @state()
    accessor noProgress;

    @state()
    accessor composition;

    @state()
    accessor isLoading;

    @query('#sdb_composition_reset_dialog')
    accessor resetAllDialog;

    get buttonLabel() {
        return this.label || translate('btnReset');
    }

    stateChanged(state) {
        this.composition = state.composition.data;
        this.isLoading = state.composition.status === 'loading';
        this.noProgress = !state.composition.data || !state.composition.data.progress || state.composition.data.progress === 'started';
    }

    static get styles() {
        return css`
            sdb-content-button[light] {
                --text-light: var(--tcg-primary-color-ontertiary, #fff);
            }
        `;
    }

    render() {
        if (this.noProgress === true) {
            return nothing;
        }

        if (this.isLoading) {
            return html`
                <sdb-content-button
                    label=${this.buttonLabel}
                    disabled>
                </sdb-content-button>
            `;
        }

        return html`
            <sdb-content-button
                label=${this.buttonLabel}
                ?outlined=${!this.disabled}
                ?disabled=${this.isLoading || this.disabled}
                ?light=${this.light}
                @click=${(e) => { this.resetAllDialog.open(); }}>
            </sdb-content-button>
            <sdb-player-dialog
                id="sdb_composition_reset_dialog"
                type="confirm"
                heading=${translate('dlgResetHeader')}
                body=${translate('dlgResetBody', { catalogName: this.composition.title })}
                confirmCaption=${translate('btnReset')}
                @confirm=${(e) => { this._executeReset(e); }}>
            </sdb-player-dialog>
        `;
    }

    firstUpdated() {
        if (this.compositionId) {
            store.dispatch(load({ compositionId: this.compositionId }));
        }
    }

    _executeReset(e) {
        store.dispatch(resetCompositionState({ compositionId: this.compositionId }));

        this.dispatchEvent(
            new CustomEvent('reset', {
                bubbles: true,
                composed: true,
                detail: {
                    isSingleItem: this.composition.compositionType === compositionTypes.COMPOSITIONTYPE_SINGLEITEM
                                  && this.composition.items.length > 0,
                },
                target: e.target
            })
        );
    }
}
